import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Label,
  OptionLabel,
  Slider,
  Switch,
  ModeToggleWrapper,
} from './ModeToggle.styled';

export const ModeToggle = ({
  className,
  disabled,
  id,
  value,
  options,
  onChange,
  blurredLayout,
  withInnerSlider,
  'data-testid': dataTestid,
}) => {
  const firstValueRef = useRef();
  const secondValueRef = useRef();
  const [sliderWidths, setSliderWidths] = useState(undefined);
  const isSwitched = value === options[1].value;

  useEffect(() => {
    if (firstValueRef.current && secondValueRef.current) {
      const { width: firstValueWidth } =
        firstValueRef.current.getBoundingClientRect();
      const { width: secondValueWidth } =
        secondValueRef.current.getBoundingClientRect();

      setSliderWidths([firstValueWidth, secondValueWidth]);
    }
  }, [firstValueRef, secondValueRef]);

  return (
    <ModeToggleWrapper>
      <Label
        data-testid={dataTestid}
        htmlFor={id}
        className={className}
      >
        <Switch
          disabled={disabled}
          blurred={blurredLayout}
        >
          <OptionLabel
            ref={firstValueRef}
            isActive={!isSwitched}
            onClick={e => onChange(options[0].value, e)}
            blurred={isSwitched && blurredLayout}
          >
            {options[0].label}
          </OptionLabel>
          <OptionLabel
            ref={secondValueRef}
            isActive={isSwitched}
            onClick={e => onChange(options[1].value, e)}
            blurred={!isSwitched && blurredLayout}
          >
            {options[1].label}
          </OptionLabel>
          {value && sliderWidths?.length > 0 && (
            <Slider
              switched={isSwitched}
              widths={sliderWidths}
              withInnerSlider={withInnerSlider}
            />
          )}
        </Switch>
      </Label>
    </ModeToggleWrapper>
  );
};

ModeToggle.propTypes = {
  className: PropTypes.string,
  'data-testid': PropTypes.string,
  disabled: PropTypes.bool,
  blurredLayout: PropTypes.bool,
  id: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
      ]).isRequired,
    }),
  ).isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
};

ModeToggle.defaultProps = {
  className: undefined,
  'data-testid': undefined,
  disabled: false,
  blurredLayout: false,
  id: undefined,
  onChange: undefined,
  withInnerSlider: false,
};

export default ModeToggle;
